<template>
  <div id="navigation">
    <div class="ui inverted huge borderless fixed fluid menu">
      <router-link to="/"><a class="header item">School Portal</a></router-link>
      <div class="right menu">
        <button class="ui button primary" v-on:click="profile()">
          Profile
        </button>
        <button class="ui red button" v-on:click="signOut()">Log out</button>
      </div>
    </div>
    <div class="ui grid">
      <div class="row">
        <div class="column" id="sidebar">
          <div class="ui secondary vertical fluid menu">
            <router-link to="/"><a class="item">Home</a></router-link>
            <router-link v-if="user.profile.role === 'Administrator'" to="/school/select">
              <a class="item">School List</a>
            </router-link>
            <router-link v-if="user.profile.role === 'Administrator'" to="/licenses">
              <a class="item">Licenses</a>
            </router-link>
            <router-link v-if="user.profile.role === 'Administrator'" to="/invoices">
              <a class="item">Invoices</a>
            </router-link>
            <div class="menu">
              <router-link v-if="user.profile.role === 'Administrator'" to="/invoices/unpaid">
                <a class="item">Unpaid invoices</a>
              </router-link>
              <router-link v-if="user.profile.role === 'Administrator'" to="/invoices/paid">
                <a class="item">Paid invoices</a>
              </router-link>
            </div>
            <router-link v-if="user.profile.role === 'Administrator'" to="/teacher/select">
              <a class="item">Last active teachers</a>
            </router-link>
            <router-link v-if="user.profile.role === 'Administrator'" to="/report/select">
              <a class="item">Reports</a>
            </router-link>
            <router-link v-if="user.profile.role === 'Administrator'" to="/website">
              <a class="item">Website</a>
            </router-link>
            <div class="menu">
              <router-link to="/website/news"><a class="item">News</a></router-link>
            </div>
            <router-link v-if="user.profile.role === 'TeacherAdministrator'" to="/school/details">
              <a class="item">Manage school</a>
            </router-link>
          </div>
        </div>
        <div class="column" id="content">
          <div class="ui basic blurring segment dimmable" :class="isLoading() ? 'dimmed' : ''">
            <div class="ui inverted dimmer transition" :class="isLoading() ? 'visible active' : 'hidden'">
              <div class="ui text loader">Loading</div>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { UserManager, WebStorageStateStore } from 'oidc-client';

export default {
  name: 'Navigation',
  computed: mapGetters({
    signedIn: 'signedIn',
    user: 'user',
    loading: 'loading',
    usersSchool: 'usersSchool',
  }),
  methods: {
    signIn() {
      // Save current location to return after authentication
      const returnUrl = window.location.href;
      // eslint-disable-next-line arrow-parens
      this.mgr.signinRedirect({ state: returnUrl }).catch((err) => console.log(err));
    },
    signOut() {
      this.mgr
        .signoutRedirect()
        .then(() => {
          this.$store.dispatch('setUser', null);
        })
        // eslint-disable-next-line arrow-parens
        .catch((err) => console.log(err));
    },
    profile() {
      window.location = process.env.OIDC_AUTHORITY;
    },
    getUser() {
      const self = this;
      this.mgr
        .getUser()
        .then((user) => {
          if (user == null || user.expired) {
            self.signIn();
          } else {
            this.$store.dispatch('setUser', user);
            if (user.profile.role === 'TeacherAdministrator') {
              this.$store.dispatch('getSchoolForUser');
            }
          }
        })
        // eslint-disable-next-line arrow-parens
        .catch((err) => console.log(err));
    },
    isLoading() {
      return this.loading;
    },
  },
  data() {
    return {
      mgr: new UserManager({
        userStore: new WebStorageStateStore(),
        authority: process.env.OIDC_AUTHORITY,
        client_id: process.env.OIDC_CLIENT_ID,
        redirect_uri: process.env.OIDC_REDIRECT_URL,
        response_type: process.env.OIDC_RESPONSE_TYPE,
        scope: process.env.OIDC_SCOPE,
        post_logout_redirect_uri: process.env.OIDC_LOGOUT_REDIRECT_URL,
        loadUserInfo: true,
      }),
    };
  },
  mounted() {
    this.getUser();
  },
};
</script>

<style type="text/css">
body {
  display: relative;
}

#sidebar {
  position: fixed;
  top: 51.8px;
  right: 0;
  bottom: 0;
  width: 18%;
  background-color: #f5f5f5;
  padding: 0px;
}

#sidebar .ui.menu {
  margin: 2em 0 0;
  font-size: 16px;
}

#sidebar .ui.menu>a.item {
  color: #337ab7;
  border-radius: 0 !important;
}

#sidebar .ui.menu>a.item.active {
  background-color: #337ab7;
  color: white;
  border: none !important;
}

#sidebar .ui.menu>a.item:hover {
  background-color: #4f93ce;
  color: white;
}

#content {
  margin-left: 20px;
  margin-right: 19%;
  width: 81%;
  margin-top: 3em;
  padding-left: 3em;
  float: left;
}

#content>.ui.grid {
  padding-right: 4em;
  padding-bottom: 3em;
}

#content h1 {
  font-size: 36px;
}

#content .ui.divider:not(.hidden) {
  margin: 0;
}

#content table.ui.table {
  border: none;
}

#content table.ui.table thead th {
  border-bottom: 2px solid #eee !important;
}

.ui.segment {
  border: 0px;
  box-shadow: none;
}

th {
  background: white;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue